import(/* webpackMode: "eager" */ "/app/src/assets/css/main.css");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleStringContextProvider"] */ "/app/src/helpers/LocaleStringContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextDirectionContextProvider"] */ "/app/src/helpers/TextDirectionContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationsContextProvider"] */ "/app/src/helpers/TranslationsContext.tsx");
